// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"style__contentWrapper__MtY-A","fixContainer":"style__fixContainer__MBOf6"};